<template>
<div class="container-fluid">
  <div class="row">
    <div class="col-xxl-5 col-lg-6 col-md-8 mx-auto">

      <div class="card">
        <div class="card-body">
          <h1 class="display-3 mb-3 text-center">Confirma tu identidad</h1>

          <div class="text-center mb-3">
            <div class="d-inline-flex align-items-center border_ text-center p-3_ pb-2_ fs-3">
              <i class="bi bi-phone-vibrate text-secondary me-2"></i>
              Ten a mano tu móvil
            </div>
            <p class="fw-medium mb-0 mt-3">Introduce el código que acabamos de enviarte por SMS a tu móvil. Ten en cuenta que puede tardar hasta un minuto en llegar: </p>
          </div>

          <form @submit.prevent="submit" class="mb-2" autocomplete="off">

            <div class="form-floating mb-3">
              <input v-model="code" type="text" class="form-control" id="floatingInput" placeholder="Código SMS" required>
              <label for="floatingInput">Código SMS</label>
            </div>

            <p class="small text-center"><a @click="() => getCode()">Reenviar código</a></p>

            <button class="w-100 btn btn-lg btn-primary mt-4" type="submit">Acceder</button>

          </form>

        </div>
      </div>

    </div>
  </div>
</div>
</template>

<script lang="ts">
import { reactive, toRefs } from "vue";
import { useRoute } from "vue-router";
import { state } from "@/api/global";

export default {
  name: "FormCodeMsg",
  props: {
    id: { type: String, required: true, default: "" },
    code_: { type: String, required: true, default: "" },
    type: { type: String, required: true, default: "" },
  },
  emits: ["onFire", "onFireCode"],
  setup(props: any, { emit }: any) {
    const route = useRoute();
    const currentPath = route.fullPath;

    const { colors } = state.configTenant.template;

    interface user_ {
      code: String;
    }

    let data = reactive<user_>({
      code: "",
    });

    const submit = async () => {
      // eslint-disable-next-line vue/custom-event-name-casing
      emit("onFire", data.code);
    };

    const getCode = async () => {
      // eslint-disable-next-line vue/custom-event-name-casing
      emit("onFireCode");
    };

    const setCode = async () => {
      data.code = props.code;
    };

    setCode();

    return {
      currentPath,
      submit,
      setCode,
      getCode,
      colors,
      ...toRefs(data),
    };
  },
};
</script>
